var store_domain = process.env.REACT_APP_APP_DOMAIN;
export function mercuryoScriptLoader(session_id) {
    var _a;
    var id = 'mercuryo-script';
    if (document.getElementById(id)) {
        return;
    }
    var url = ('https:' == document.location.protocol ? 'https://' : 'http://') +
        'beacon.riskified.com?shop=' +
        store_domain +
        '&sid=' +
        session_id;
    var s = document.createElement('script');
    s.id = id;
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    var x = document.getElementsByTagName('script')[0];
    (_a = x.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(s, x);
}
export function platform() {
    var width = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    return width <= 768 ? 'mobile_web' : 'desktop_web';
}
